module.exports = __webpack_public_path__ + "static/img/proximal.65c3d64.jpeg";


//////////////////
// WEBPACK FOOTER
// ./static/images/proximal.jpeg
// module id = PqXI
// module chunks = 1